import { normal } from '../defaultSpacing';
import { mapState as rootMapState } from 'pinia';
import {  usePageStore } from '@/store';
export default {
    i18next: {
        ns: 'md-invalid'
    },
    data: function() {
        return {
            ...normal
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    beforeMount: function() {
        // soft 404
        var metaRobots = document.querySelector('meta[name="robots"]');
        // if there was no robots meta tag, add one
        if (!metaRobots) {
            metaRobots = document.createElement('meta');
            metaRobots.setAttribute('name', 'robots');
            document.head.appendChild(metaRobots);
        }
        // tell Google to exclude this page from the index
        metaRobots.setAttribute('content', 'noindex');
    },
    mounted() {
        if (this.page.pageKey === 'listing-invalid' &&  !window.location.href.includes("debugger=1")) {
            setTimeout(() => {
                window.location.href = '/'
            }, 5000);
        }
    }
};
